export const dmsHelper = {
  methods: {
    base64ToArrayBuffer(data) {
      var bString = window.atob(decodeURIComponent(data));
      var bLength = bString.length;
      var bytes = new Uint8Array(bLength);
      for (var i = 0; i < bLength; i++) {
        var ascii = bString.charCodeAt(i);
        bytes[i] = ascii;
      }
      return bytes;
    },
    base64toPDF(data, ext) {
      var bufferArray = this.base64ToArrayBuffer(data);

      var xType = '';

      var extension = ext.toString().toLowerCase();
      
      /* mime type ??? */
      if (extension == 'pdf') {
        xType = 'application/pdf';
      } else if (
        extension.match('jp*') ||
        extension.match('pn*') ||
        extension.match('bm*')
      ) {
        xType = 'image/' + extension;
      } else if (extension.match('xls*')) {
        xType =
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      } else if (extension.match('doc*')) {
        xType =
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
      } else {
        xType = 'application/octet-stream';
      }

      var blobStore = new Blob([bufferArray], { type: xType });

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blobStore);

         return;
      }
      return blobStore;
    },
    base64toEML(data) {
      var bufferArray = this.base64ToArrayBuffer(data);

      var xType = '';
      xType = 'message/rfc822';
      var blobStore = new Blob([bufferArray], { type: xType });

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blobStore);
        return;
      }

      return blobStore;
    },
    pdfDataDownload(data, filename, extension) {

      var blob = this.base64toPDF(data, extension);
      var dataX = window.URL.createObjectURL(blob);

      var link = document.createElement('a');
      document.body.appendChild(link);
      link.href = dataX;

      // 20210330 BL - chybajuca extension fo FF
      link.download = filename + '.' + extension; //'.pdf';

      link.click();

      window.URL.revokeObjectURL(dataX);
      link.remove();    
    },
    pdfDataShow(data, filename, extension) {

      var blob = this.base64toPDF(data, extension);
      var dataX = window.URL.createObjectURL(blob);

      var link = document.createElement('a');
      document.body.appendChild(link);
      link.href = dataX;
      link.download = filename;

      var w = window.open(link.href, link.download);
      setTimeout(() => w.document.title = link.download,10);

      window.URL.revokeObjectURL(dataX);
      link.remove();
    },
    emlDataDownload(data, name) {
      var blob = this.base64toEML(data);
      var dataX = window.URL.createObjectURL(blob);

      var link = document.createElement('a');

      link.href = dataX;
      link.download = name.replaceAll('/', '');

      document.body.appendChild(link);

      link.click();

      window.URL.revokeObjectURL(dataX);
      link.remove();
    },
  },
};
